export default "__VITE_ASSET__u$eQFKSI__"